<div class="dialog-header">
	<div class="header-title">
		<span class="header-span" *ngIf="!isMobile">{{dialogHeader}}</span>
		<span class="header-span" *ngIf="isMobile">Send Email</span>
	</div>

	<div class="buttons-block">
		<button class="header-button report-button" mat-button (click)="openPdfReport()">
			<span>Report</span>
		</button>
	</div>

	<div class="buttons-block" *ngIf="canBeEdited">
		<button class="header-button send-button" mat-button (click)="sendEmail()"
			[disabled]="!showSendButton || submitLoading"
			[ngClass]="{'disabled-button': !showSendButton || submitLoading}">
			<span *ngIf="!submitLoading">Send</span>
			<lib-mini-progress-spinner *ngIf="submitLoading"></lib-mini-progress-spinner>
		</button>
	</div>

	<button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
		<mat-icon>clear</mat-icon>
	</button>
</div>

<div class="middle-content">
	<div class="info-block" *ngIf="!showLoadingSpinner && clientNf.resolvedTime">
		<span class="info-msg">Sent By: {{clientNf.sentBy?.name}}
			{{clientNf.resolvedTime | date: 'MMM dd h:mm a'}}</span>

	</div>
	<div class="text-block" *ngIf="!showLoadingSpinner">
		<textarea matInput [required]="true" [(ngModel)]="textAreaMessage" name="message"
			[disabled]="!canBeEdited || submitLoading" [ngClass]="{'can-be-edited': !canBeEdited}"></textarea>
	</div>

	<div class="text-block loading-block" *ngIf="showLoadingSpinner">
		<lib-progress-spinner></lib-progress-spinner>
	</div>
</div>